export default "/e891d4a0bdc60f2a6a9b4e97d7422547d2a79dc5/83e791c702f67cc0242109b04d241be7.svg";